(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["adobe-locales"] = factory();
	else
		root["adobe-locales"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCountryLanguages = exports.createLocaleFromIMS = exports.getAppNameFromURL = exports.isUmbrellaRegionApp = exports.getUmbrellaRegions = exports.getAllLocales = exports.langScript = exports.normalize = exports.priuse = exports.region = exports.script = exports.extlang = exports.lang = exports.findValueByKeyIgnoreCase = exports.findKey = undefined;

var _locales = __webpack_require__(2);

var locales = _interopRequireWildcard(_locales);

var _region2 = __webpack_require__(46);

var _region3 = _interopRequireDefault(_region2);

var _apps = __webpack_require__(3);

var _apps2 = _interopRequireDefault(_apps);

var _getAppLocale = __webpack_require__(1);

var _getAppLocale2 = _interopRequireDefault(_getAppLocale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2018 Adobe Systems Incorporated
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe Systems Incorporated and its suppliers,
* if any.  The intellectual and technical concepts contained
* herein are proprietary to Adobe Systems Incorporated and its
* suppliers and are protected by all applicable intellectual property
* laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe Systems Incorporated.
**************************************************************************/

var pattern = /^([a-zA-Z]{2})(?:[_-]+([a-zA-Z]{3})(?=$|[_-]+))?(?:[_-]+([a-zA-Z]{4})(?=$|[_-]+))?(?:[_-]+([a-zA-Z]{2}|[0-9]{3})(?=$|[_-]+))?(?:-x-([a-zA-Z0-9]{1,8})(?=$))?$/;

var _match = function _match(locale) {
  return locale.match(pattern) || [];
};

/**
 * given an object, return its value based on passed condition
 * @param {object} obj
 * @param {object} fun
 */
var findKey = function findKey(obj, fun) {
  return Object.keys(obj).filter(function (x) {
    return fun(obj[x]);
  })[0];
};

/**
* given an object, return its value based on passed case-insensitive key
* @param {object} obj
* @param {string} key
*/
var findValueByKeyIgnoreCase = function findValueByKeyIgnoreCase(obj, key) {
  return key !== undefined ? obj[Object.keys(obj).filter(function (k) {
    return k.toLowerCase() === key.toLowerCase();
  })[0]] : undefined;
};

/* 
  https://www.w3.org/International/articles/language-tags/#rfc

  pattern: language-extlang-script-region-variant-extension-privateuse

  type      pattern
  language  2-letter or 3-letter
  extlang   3-letter
  script    4-letter
  region    2-letter or 3-number
  private   -x-****
*/
/**
 * "language" sub-tab of a locale
 * @param {string} locale - locale name
 */
var lang = function lang(locale) {
  return _match(locale)[1] || '';
};

/**
 * "extlang" sub-tab of a locale
 * @param {string} locale - locale name
 */
var extlang = function extlang(locale) {
  return _match(locale)[2] || '';
};

/**
 * "script" sub-tab of a locale
 * @param {string} locale - locale name
 */
var script = function script(locale) {
  return _match(locale)[3] || '';
};

/**
 * "region" sub-tab of a locale
 * @param {string} locale - locale name
 */
var region = function region(locale) {
  return _match(locale)[4] || '';
};

/**
 * "private use" sub-tab of a locale
 * @param {string} locale - locale name
 */
var priuse = function priuse(locale) {
  return _match(locale)[5] || '';
};

/**
 * "language" + "script" sub-tab of a locale
 * @param {string} locale - locale name
 * @param {string} camelizeScriptName - if camelize Script Name
 */
var langScript = function langScript(locale) {
  var camelizeScriptName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var ls = '';
  var matches = _match(locale);

  if (matches.length > 0) {
    if (matches[3] !== undefined) {
      // has script
      if (camelizeScriptName === true) {
        ls = matches[1] + '-' + matches[3].charAt(0).toUpperCase() + matches[3].slice(1);
      } else {
        ls = matches[1] + '-' + matches[3];
      }
    } else if (matches[1].toLowerCase() === 'zh' && matches[4] !== undefined) {

      var _region = matches[4].toLowerCase();

      if (['tw', 'hk', 'mo'].includes(_region)) {
        ls = 'zh-Hant';
      } else {
        ls = 'zh-Hans';
      }
    } else {
      ls = matches[1];
    }
  }

  return ls;
};

/*
  Generate all app locale mapping.
*/
var allLocales = {};

Object.keys(locales).forEach(function (app) {
  var appLocales = locales[app];

  Object.keys(appLocales).forEach(function (appLocale) {
    var mappedLocale = appLocales[appLocale];
    // const lowerMappedLocale = mappedLocale.toLowerCase();

    allLocales[appLocale] = mappedLocale;

    if (allLocales[mappedLocale] === undefined) {
      allLocales[mappedLocale] = mappedLocale;
    }

    // if (allLocales[lowerMappedLocale] === undefined) {
    //   allLocales[lowerMappedLocale] = mappedLocale;
    // }
  });
});

/**
 * get all app locale mapping
 */
var getAllLocales = function getAllLocales() {
  return allLocales;
};

/**
 * get all app locale mapping
 */
var getUmbrellaRegions = function getUmbrellaRegions(region) {
  return findKey(_apps.umbrellaRegions, function (v) {
    return v.includes(region.toLowerCase());
  });
};

/**
 * check if one of apps that have Umbrella Regions such as "mena", "sea"
 */
var isUmbrellaRegionApp = function isUmbrellaRegionApp(app) {
  return _apps.umbrellaRegionApp.includes(app);
};

/**
 * returns BCP-47 form of a locale
 * @param {string} locale - locale name
 * @param {string} app - optional, which can handle app-specific case, like "uk" returns "en-GB" for app "adobedotcom", while it returns "uk-UA" in other cases.
 */
var normalize = function normalize(locale, app) {
  var normalizedLocale = void 0;

  if (app) {
    var appLocale = (0, _getAppLocale2.default)(app, locale);

    normalizedLocale = locales[app][appLocale];
  }

  return normalizedLocale || findValueByKeyIgnoreCase(getAllLocales(), locale);
};

/**
 * helps to construct a locale using the language of an app and the user's IMS country. 
 * If the language is not supported by adobe.com for that country, it will change to the 
 * default language of that country that adobe.com supports. For example, if en-US is the 
 * app language and JP is the IMS code, this will result in "ja-JP"
 */
var createLocaleFromIMS = function createLocaleFromIMS(locale, imsCountryCode) {
  var match = false;
  var newLocale = 'en-US';

  if (typeof locale === 'string' && typeof imsCountryCode === 'string' && imsCountryCode.length === 2) {
    var language = langScript(locale, true);
    var imsCountryCodeU = imsCountryCode.toUpperCase();
    var countryLangs = _region3.default[imsCountryCodeU];

    if (countryLangs !== undefined) {
      if (countryLangs.includes(language)) {
        match = true;
      } else {
        language = countryLangs[0] || 'en';
      }

      newLocale = language + '-' + imsCountryCodeU;
    }
  }

  return {
    match: match,
    locale: newLocale
  };
};

/**
 * helper to strip url protocol and www
 * @param {string} url - url name
 * @returns {string} url w/o protocol and www
 */
var stripUrl = function stripUrl(url) {
  return url.replace(/^(https?:\/\/)/, '').replace(/^(www\.)/, '');
};

/**
 * get app code name from a url
 * @param {string} url - url name
 * @returns {string} app name
 */
var getAppNameFromURL = function getAppNameFromURL(url) {
  var appName = void 0;

  if (typeof url === 'string' && url.length) {
    var strippedUrl = stripUrl(url.trim().toLowerCase());

    appName = findKey(_apps2.default, function (a) {
      return strippedUrl.indexOf(stripUrl(a.production)) === 0 || strippedUrl.indexOf(stripUrl(a.stage)) === 0;
    });
  }

  return appName;
};

/**
 * get country supported languages list
 * @param {string} imsCountryCode - country code 2-char
 * @returns {array} languages list. default to ['en']
 */
var getCountryLanguages = function getCountryLanguages(imsCountryCode) {
  var defaultLangs = ['en'];
  var langs = typeof imsCountryCode === 'string' ? _region3.default[imsCountryCode.toUpperCase()] || [] : defaultLangs;

  return langs.length ? langs : defaultLangs;
};

exports.findKey = findKey;
exports.findValueByKeyIgnoreCase = findValueByKeyIgnoreCase;
exports.lang = lang;
exports.extlang = extlang;
exports.script = script;
exports.region = region;
exports.priuse = priuse;
exports.normalize = normalize;
exports.langScript = langScript;
exports.getAllLocales = getAllLocales;
exports.getUmbrellaRegions = getUmbrellaRegions;
exports.isUmbrellaRegionApp = isUmbrellaRegionApp;
exports.getAppNameFromURL = getAppNameFromURL;
exports.createLocaleFromIMS = createLocaleFromIMS;
exports.getCountryLanguages = getCountryLanguages;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _locales = __webpack_require__(2);

var locales = _interopRequireWildcard(_locales);

var _utils = __webpack_require__(0);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/*
 * @param {string} app - app code. For a complete apps code, see https://git.corp.adobe.com/intl/adobe-locales#supported-apps
 * @param {string} locale - locale name, it does not have to be the one destination app uses.
 * @param {string} fallback - fallback locale name, it does not have to be the one destination app uses.
 * @returns {string} destination app locale name. Returns "" if passed locale is not supported in the app. 
 */
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2018 Adobe Systems Incorporated
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe Systems Incorporated and its suppliers,
* if any.  The intellectual and technical concepts contained
* herein are proprietary to Adobe Systems Incorporated and its
* suppliers and are protected by all applicable intellectual property
* laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe Systems Incorporated.
**************************************************************************/

var getAppLocale = function getAppLocale(app, locale, fallback) {
  // must be a valid app
  if (locales[app] === undefined) {
    return '';
  }

  var appLocale = void 0;

  // exact locale
  if (locale && locales[app][locale] !== undefined) {
    appLocale = locale;
  } else {

    // otherwise find a match in all locales
    var adobeLocales = (0, _utils.getAllLocales)();

    if (locale && !((0, _utils.lang)(locale) === '' && adobeLocales[locale] === undefined)) {
      var normalizedLocale = (0, _utils.findValueByKeyIgnoreCase)(adobeLocales, locale);

      if (typeof normalizedLocale === 'string') {
        appLocale = (0, _utils.findKey)(locales[app], function (v) {
          return v === normalizedLocale;
        });
      } else {
        normalizedLocale = locale;
      }

      if (appLocale === undefined && (0, _utils.lang)(normalizedLocale) !== '') {
        // try speical regions, before we moved to lang only
        if (appLocale === undefined && (0, _utils.isUmbrellaRegionApp)(app)) {
          var umbrellaRegion = (0, _utils.getUmbrellaRegions)((0, _utils.region)(locale));

          if (umbrellaRegion) {
            // try lang and region combination first
            var regionLocaleX = (0, _utils.lang)(locale) + '-x-' + umbrellaRegion.toUpperCase();
            var regionLocale = locale.slice(0, -2) + umbrellaRegion.toUpperCase();

            appLocale = (0, _utils.findKey)(locales[app], function (v) {
              return v === regionLocaleX || v === regionLocale;
            });
            // try region only
            if (appLocale === undefined && locales[app][umbrellaRegion] !== undefined) {
              appLocale = umbrellaRegion;
            }
          }
        }

        // try lang and script combination
        if (appLocale === undefined && (0, _utils.script)(normalizedLocale) !== '') {
          var withScript = normalizedLocale.substr(0, 7).toLowerCase();

          appLocale = (0, _utils.findKey)(locales[app], function (v) {
            return v.substr(0, 7).toLowerCase() === withScript;
          });
        }

        // finally try lang only
        if (appLocale === undefined) {
          var withLang = normalizedLocale.substr(0, 2).toLowerCase();

          appLocale = (0, _utils.findKey)(locales[app], function (v) {
            return v.substr(0, 2).toLowerCase() === withLang;
          });
        }
      }
    }

    if (appLocale === undefined && fallback !== undefined) {
      appLocale = (0, _utils.findKey)(locales[app], function (v) {
        return v === fallback || v === adobeLocales[fallback];
      });
    }
  }

  // stock has nothing for en-US locale
  if (app === 'stock' && appLocale === 'us') {
    appLocale = '';
  }

  return appLocale || '';
};

exports.default = getAppLocale;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ucv = __webpack_require__(7);

Object.defineProperty(exports, 'academic_verification', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ucv).default;
  }
});

var _adminconsole = __webpack_require__(8);

Object.defineProperty(exports, 'adminconsole', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_adminconsole).default;
  }
});

var _adobeaccount = __webpack_require__(9);

Object.defineProperty(exports, 'adobeaccount', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_adobeaccount).default;
  }
});

var _assets = __webpack_require__(10);

Object.defineProperty(exports, 'assets', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_assets).default;
  }
});

var _behance = __webpack_require__(11);

Object.defineProperty(exports, 'behance', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_behance).default;
  }
});

var _cchome = __webpack_require__(12);

Object.defineProperty(exports, 'cchome', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_cchome).default;
  }
});

var _ccsearch = __webpack_require__(13);

Object.defineProperty(exports, 'ccsearch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ccsearch).default;
  }
});
Object.defineProperty(exports, 'comments', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_assets).default;
  }
});

var _color = __webpack_require__(14);

Object.defineProperty(exports, 'color', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_color).default;
  }
});

var _community = __webpack_require__(15);

Object.defineProperty(exports, 'community', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_community).default;
  }
});

var _creativecloudapp = __webpack_require__(16);

Object.defineProperty(exports, 'creativecloudapp', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_creativecloudapp).default;
  }
});

var _dcweb = __webpack_require__(17);

Object.defineProperty(exports, 'dcweb', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_dcweb).default;
  }
});

var _editbilling = __webpack_require__(18);

Object.defineProperty(exports, 'editbilling', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_editbilling).default;
  }
});

var _experiencecloud = __webpack_require__(19);

Object.defineProperty(exports, 'experiencecloud', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_experiencecloud).default;
  }
});

var _helpx = __webpack_require__(20);

Object.defineProperty(exports, 'helpx', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_helpx).default;
  }
});

var _ims = __webpack_require__(21);

Object.defineProperty(exports, 'ims', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ims).default;
  }
});

var _lightroom = __webpack_require__(22);

Object.defineProperty(exports, 'lightroom', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_lightroom).default;
  }
});

var _jarvis = __webpack_require__(23);

Object.defineProperty(exports, 'jarvis', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_jarvis).default;
  }
});

var _mcs = __webpack_require__(24);

Object.defineProperty(exports, 'mcs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_mcs).default;
  }
});

var _mt = __webpack_require__(25);

Object.defineProperty(exports, 'mt', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_mt).default;
  }
});

var _ngl = __webpack_require__(26);

Object.defineProperty(exports, 'ngl', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ngl).default;
  }
});

var _acrobat_plan = __webpack_require__(27);

Object.defineProperty(exports, 'acrobat_plan', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_acrobat_plan).default;
  }
});

var _panellicensing = __webpack_require__(28);

Object.defineProperty(exports, 'panel_licensing', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_panellicensing).default;
  }
});

var _portfolio = __webpack_require__(29);

Object.defineProperty(exports, 'portfolio', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_portfolio).default;
  }
});

var _publiclinks = __webpack_require__(30);

Object.defineProperty(exports, 'publiclinks', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_publiclinks).default;
  }
});

var _react_spectrum = __webpack_require__(31);

Object.defineProperty(exports, 'react_spectrum', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_react_spectrum).default;
  }
});

var _redemptionui = __webpack_require__(32);

Object.defineProperty(exports, 'redemption_ui', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_redemptionui).default;
  }
});
Object.defineProperty(exports, 'sharesheet', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_assets).default;
  }
});

var _spark = __webpack_require__(33);

Object.defineProperty(exports, 'spark', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_spark).default;
  }
});

var _stock = __webpack_require__(34);

Object.defineProperty(exports, 'stock', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_stock).default;
  }
});

var _fonts = __webpack_require__(35);

Object.defineProperty(exports, 'fonts', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_fonts).default;
  }
});
Object.defineProperty(exports, 'commerce_ui', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ucv).default;
  }
});
Object.defineProperty(exports, 'unifiedcheckout', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ucv).default;
  }
});

var _ucv2 = __webpack_require__(36);

Object.defineProperty(exports, 'unifiedcheckout_v1', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ucv2).default;
  }
});

var _unifiedpanel = __webpack_require__(37);

Object.defineProperty(exports, 'unifiedpanel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_unifiedpanel).default;
  }
});

var _uss = __webpack_require__(38);

Object.defineProperty(exports, 'uss', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_uss).default;
  }
});

var _utilitynav = __webpack_require__(39);

Object.defineProperty(exports, 'utilitynav', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_utilitynav).default;
  }
});

var _ututs = __webpack_require__(40);

Object.defineProperty(exports, 'ututs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ututs).default;
  }
});

var _xd = __webpack_require__(41);

Object.defineProperty(exports, 'xd', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_xd).default;
  }
});

var _mini_plans_photoshop_lightroom_start_trial = __webpack_require__(42);

Object.defineProperty(exports, 'mini_plans_photoshop_lightroom_start_trial', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_mini_plans_photoshop_lightroom_start_trial).default;
  }
});

var _mini_plans = __webpack_require__(43);

Object.defineProperty(exports, 'mini_plans', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_mini_plans).default;
  }
});

var _adobedotcom = __webpack_require__(44);

Object.defineProperty(exports, 'adobedotcom', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_adobedotcom).default;
  }
});
Object.defineProperty(exports, 'globalnav', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_adobedotcom).default;
  }
});
Object.defineProperty(exports, 'switchplan_app', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_adobeaccount).default;
  }
});

var _supplement = __webpack_require__(45);

Object.defineProperty(exports, '_supplement', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_supplement).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var apps = {
  'academic_verification': {
    'stage': 'https://commerce-stg.adobe.com/academic-verification',
    'production': 'https://commerce.adobe.com/academic-verification'
  },
  'acrobat_plan': {
    'stage': 'https://stage.acrobat.adobe.com',
    'production': 'https://acrobat.adobe.com'
  },
  'adobeaccount': {
    'stage': 'https://stage.account.adobe.com',
    'production': 'https://account.adobe.com'
  },
  'adminconsole': {
    'stage': 'https://stage.adminconsole.adobe.com',
    'production': 'https://adminconsole.adobe.com'
  },
  'assets': {
    'stage': 'https://assets-stage.adobecc.com',
    'production': 'https://assets.adobe.com'
  },
  'behance': {
    'stage': 'https://net.s2stagehance.com',
    'production': 'https://www.behance.net'
  },
  'cchome': {
    'stage': 'https://stage.creativecloud.adobe.com',
    'production': 'https://creativecloud.adobe.com'
  },
  'color': {
    'stage': 'https://colorweb-stage.adobeku.com',
    'production': 'https://color.adobe.com'
  },
  'community': {
    'stage': 'https://community-stg.adobe.com',
    'production': 'https://community.adobe.com'
  },
  'creativecloudapp': {
    'stage': 'https://stage.ccmui.adobe.com',
    'production': 'https://creative.adobe.com'
  },
  'dcweb': {
    'stage': 'https://dc-stage.documentcloudtest.com',
    'production': 'https://documentcloud.adobe.com'
  },
  'experiencecloud': {
    'stage': 'https://experiencecloud-stage.adobe.com',
    'production': 'https://experiencecloud.adobe.com'
  },
  'fonts': {
    'stage': 'https://fonts-relstage.adobe.com',
    'production': 'https://fonts.adobe.com'
  },
  'helpx': {
    'stage': 'https://helpx.stage.adobe.com',
    'production': 'https://helpx.adobe.com'
  },
  'ims': {
    'stage': 'https://ims-na1-stg1.adobelogin.com',
    'production': 'https://adobeid-na1.services.adobe.com'
  },
  'lightroom': {
    'stage': 'https://stage.adobelr.com',
    'production': 'https://lightroom.adobe.com'
  },
  'mini_plans': {
    'stage': 'https://www.stage.adobe.com/mini-plans',
    'production': 'https://www.adobe.com/mini-plans'
  },
  'ngl': {
    'stage': 'https://workflow-stage.licenses.adobe.com',
    'production': 'https://workflow.licenses.adobe.com'
  },
  'portfolio': {
    'stage': 'https://portfolio.ccpsx.com',
    'production': 'https://portfolio.adobe.com'
  },
  'redemption_ui': {
    'stage': 'https://redeem-stg.adobe.com',
    'production': 'https://redeem.adobe.com'
  },
  'stock': {
    'stage': 'https://primary.stock.stage.adobe.com',
    'production': 'https://stock.adobe.com'
  },
  'spark': {
    'stage': 'https://stage.adobeprojectm.com',
    'production': 'https://spark.adobe.com'
  },
  'commerce_ui': {
    'stage': 'https://commerce-stg.adobe.com',
    'production': 'https://commerce.adobe.com'
  },
  'unifiedcheckout': {
    'stage': 'https://commerce-stg.adobe.com',
    'production': 'https://commerce.adobe.com'
  },
  'xd': {
    'stage': 'https://stage.xd.adobe.com',
    'production': 'https://xd.adobe.com'
  },
  'adobedotcom': {
    'stage': 'https://www.stage.adobe.com',
    'production': 'https://www.adobe.com'
  }
};

// includes all apps that has locale as part of URL path, like "https://www/adobe.com/us/", compapred to query param like "https://cchome.adobe.com/?locale=en"
var urlApp = exports.urlApp = ['adobedotcom', 'helpx', 'stock', 'accountmanagement', 'creativecloudapp', 'acrobat_plan', 'ngl', 'color', 'mini_plans'];

// includes all apps that use "lang" as query param instead of "locale"
var langParamApp = exports.langParamApp = ['adobeaccount', 'redemption_ui', 'unifiedcheckout', 'academic_verification', 'community'];

// includes all apps that use umbrella regions
var umbrellaRegionApp = exports.umbrellaRegionApp = ['adobedotcom', 'helpx', 'globalnav', 'ims', 'acrobat_plan', 'ngl', 'jarvis', 'mini_plans'];

var umbrellaRegions = exports.umbrellaRegions = {
  africa: ['africa', 'ao', 'bf', 'bi', 'bj', 'bw', 'cd', 'cf', 'cg', 'ci', 'cm', 'cv', 'dj', 'er', 'et', 'ga', 'gh', 'gm', 'gn', 'gq', 'gw', 'ke', 'km', 'lr', 'ls', 'mg', 'ml', 'mu', 'mw', 'mz', 'na', 'ne', 'ng', 'rw', 'sc', 'sd', 'sl', 'sn', 'so', 'st', 'sz', 'td', 'tg', 'tz', 'ug', 'za', 'zm', 'zw'],
  cis: ['cis', 'am', 'az', 'by', 'ge', 'kg', 'kz', 'md', 'tj', 'tm', 'uz'],
  la: ['la', 'ar', 'bl', 'bo', 'br', 'bz', 'cl', 'co', 'cr', 'cu', 'do', 'ec', 'fk', 'gf', 'gt', 'gy', 'hn', 'ht', 'mf', 'mq', 'ni', 'pa', 'pe', 'pr', 'py', 'sr', 'sv', 'uy', 've', 'tt'],
  mena: ['mena', 'ae', 'bh', 'dz', 'eg', 'jo', 'kw', 'lb', 'ma', 'om', 'qa', 'sa', 'tn', 'ye', 'iq', 'ly', 'mr'],
  sea: ['sea', 'id', 'my', 'ph', 'sg', 'th', 'vn', 'lk'],
  hk: ['mo'],
  ie: ['hr']
};

exports.default = apps;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getAppLocale = __webpack_require__(1);

var _getAppLocale2 = _interopRequireDefault(_getAppLocale);

var _utils = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * @param {string} app - app code
 * @param {string} locale - locale name
 * @param {string} imsCountryCode - two-character IMS country code
 * @returns {{locale: string, match: boolean}}
 */
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2018 Adobe Systems Incorporated
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe Systems Incorporated and its suppliers,
* if any.  The intellectual and technical concepts contained
* herein are proprietary to Adobe Systems Incorporated and its
* suppliers and are protected by all applicable intellectual property
* laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe Systems Incorporated.
**************************************************************************/

var getAppLocaleFromIMS = function getAppLocaleFromIMS(app, locale, imsCountryCode) {
  if (typeof app === 'string') {
    app = app.replace(/-/g, '_');
  }

  var _createLocaleFromIMS = (0, _utils.createLocaleFromIMS)(locale, imsCountryCode),
      newLocale = _createLocaleFromIMS.locale,
      match = _createLocaleFromIMS.match;

  var appLocale = (0, _getAppLocale2.default)(app, newLocale);

  // we have to support mini_plans a different list (a few less) than adobe.com
  // https://jira.corp.adobe.com/browse/LS-7436
  if (app === 'mini_plans' || app === 'mini_plans_photoshop_lightroom_start_trial') {
    match = match && newLocale === (0, _utils.normalize)(appLocale, app);
  }

  return {
    match: match,
    locale: appLocale
  };
};

exports.default = getAppLocaleFromIMS;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apps = __webpack_require__(3);

var _utils = __webpack_require__(0);

var _getAppLocale = __webpack_require__(1);

var _getAppLocale2 = _interopRequireDefault(_getAppLocale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * @param {string} url - the destination app url
 * @param {string} locale - locale you want to pass, it doesn not have to be the one destination app uses.
 * @returns {string} destination app localized url
 */
var getLocalizedURL = function getLocalizedURL(url, locale) {

  try {
    if (typeof url !== 'string' || typeof locale !== 'string') {
      throw Error('expect "url" and "locale" to be string.');
    }

    var localizedUrl = url;
    var app = (0, _utils.getAppNameFromURL)(url);

    if (app === undefined) {
      throw Error('this app is not supported yet: "' + url + '"');
    }

    var appLocale = (0, _getAppLocale2.default)(app, locale);

    if (appLocale) {
      var allLocales = (0, _utils.getAllLocales)();

      if (_apps.urlApp.includes(app)) {

        // remove english path as it doesn't work for adobe.com and helpx URL w/paths
        if (appLocale === 'en' || appLocale === 'us') {
          appLocale = '';
        }

        var pattern = /adobe(?:stock){0,1}\.com\/(.*?)(?=\/|$)/;

        if (app === 'acrobat_plan') {
          pattern = /adobe\.com\/(.{5,10}?)(?=\/|$)/;
        }

        var alocale = (url.match(pattern) || [])[1];

        if (alocale !== undefined && allLocales[alocale] !== undefined) {
          localizedUrl = url.replace('.com/' + alocale, appLocale === '' ? '.com' : '.com/' + appLocale);
        } else {
          if (appLocale !== '') {
            localizedUrl = url.replace('.com', '.com/' + appLocale);
          }
        }
      } else {
        var paramName = _apps.langParamApp.includes(app) ? app === 'community' ? 'profile.language' : 'lang' : 'locale';

        var reg = new RegExp('(' + paramName + '=)(.*?)(?=&|$)');
        var loc = (url.match(reg) || [])[2];

        if (loc !== undefined) {
          localizedUrl = url.replace(reg, '$1' + appLocale);
        } else {
          localizedUrl = url + (url.includes('?') ? '&' : '?') + paramName + '=' + appLocale;
        }
      }
    }

    return localizedUrl;
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      console.error('[getLocalizedURL] Error: ' + e.message);
    }
  }

  return url;
}; /*************************************************************************
   * ADOBE CONFIDENTIAL
   * ___________________
   *
   *  Copyright 2018 Adobe Systems Incorporated
   *  All Rights Reserved.
   *
   * NOTICE:  All information contained herein is, and remains
   * the property of Adobe Systems Incorporated and its suppliers,
   * if any.  The intellectual and technical concepts contained
   * herein are proprietary to Adobe Systems Incorporated and its
   * suppliers and are protected by all applicable intellectual property
   * laws, including trade secret and copyright laws.
   * Dissemination of this information or reproduction of this material
   * is strictly forbidden unless prior written permission is obtained
   * from Adobe Systems Incorporated.
   **************************************************************************/
exports.default = getLocalizedURL;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getAppLocale = __webpack_require__(1);

Object.defineProperty(exports, 'getAppLocale', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getAppLocale).default;
  }
});

var _getAppLocales = __webpack_require__(47);

Object.defineProperty(exports, 'getAppLocales', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getAppLocales).default;
  }
});

var _getAppLocaleFromIMS = __webpack_require__(4);

Object.defineProperty(exports, 'getAppLocaleFromIMS', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getAppLocaleFromIMS).default;
  }
});

var _getLocalizedURL = __webpack_require__(5);

Object.defineProperty(exports, 'getLocalizedURL', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getLocalizedURL).default;
  }
});

var _getLocalizedURLFromIMS = __webpack_require__(49);

Object.defineProperty(exports, 'getLocalizedURLFromIMS', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getLocalizedURLFromIMS).default;
  }
});

var _parseLocaleParam = __webpack_require__(50);

Object.defineProperty(exports, 'parseLocaleParam', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_parseLocaleParam).default;
  }
});

var _utils = __webpack_require__(0);

Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _utils[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'zh-hant': 'zh-Hant-TW'
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'zh-cn': 'zh-Hans-CN',
  'zh-tw': 'zh-Hant-TW'
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'ar': 'ar-AE',
  'bg': 'bg-BG',
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'et': 'et-EE',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'he': 'he-IL',
  'hu': 'hu-HU',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'lt': 'lt-LT',
  'lv': 'lv-LV',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ro': 'ro-RO',
  'ru': 'ru-RU',
  'sk': 'sk-SK',
  'sl': 'sl-SI',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'uk': 'uk-UA',
  'zh-Hans': 'zh-Hans-CN',
  'zh-Hant': 'zh-Hant-TW'
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'zh-Hans': 'zh-Hans-CN',
  'zh-Hant': 'zh-Hant-TW'
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs-CZ': 'cs-CZ',
  'da-DK': 'da-DK',
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'fi-FI': 'fi-FI',
  'fr-FR': 'fr-FR',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'nb-NO': 'nb-NO',
  'nl-NL': 'nl-NL',
  'pl-PL': 'pl-PL',
  'pt-BR': 'pt-BR',
  'ru-RU': 'ru-RU',
  'sv-SE': 'sv-SE',
  'tr-TR': 'tr-TR',
  'zh-CN': 'zh-Hans-CN',
  'zh-TW': 'zh-Hant-TW'
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'zh-Hans': 'zh-Hans-CN',
  'zh-Hant': 'zh-Hant-TW'
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'hu': 'hu-HU',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'uk': 'uk-UA',
  'zh-Hans': 'zh-Hans-CN',
  'zh-Hant': 'zh-Hant-TW'
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'zh': 'zh-Hant-TW'
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fr': 'fr-FR',
  'ja': 'ja-JP',
  'pt': 'pt-BR'
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'zh-cn': 'zh-Hans-CN',
  'zh-tw': 'zh-Hant-TW'
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs-CZ': 'cs-CZ',
  'da-DK': 'da-DK',
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'en-GB': 'en-GB',
  'es-ES': 'es-ES',
  'fi-FI': 'fi-FI',
  'fr-FR': 'fr-FR',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'nb-NO': 'nb-NO',
  'nl-NL': 'nl-NL',
  'pl-PL': 'pl-PL',
  'pt-BR': 'pt-BR',
  'ru-RU': 'ru-RU',
  'sv-SE': 'sv-SE',
  'tr-TR': 'tr-TR',
  'zh-CN': 'zh-Hans-CN',
  'zh-TW': 'zh-Hant-TW'
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'ar': 'ar-AE',
  'bg': 'bg-BG',
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'et': 'et-EE',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'he': 'he-IL',
  'hu': 'hu-HU',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'lt': 'lt-LT',
  'lv': 'lv-LV',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ro': 'ro-RO',
  'ru': 'ru-RU',
  'sk': 'sk-SK',
  'sl': 'sl-SI',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'uk': 'uk-UA',
  'zh-hans': 'zh-Hans-CN',
  'zh-hant': 'zh-Hant-TW'
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fr': 'fr-FR',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko-kr': 'ko-KR',
  'pt-br': 'pt-BR',
  'zh-cn': 'zh-Hans-CN',
  'zh-tw': 'zh-Hant-TW'
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'mena_ar': 'ar-x-MENA', // Arabic (Middle East and North Africa)
  'bg': 'bg-BG', // Bulgarian (Bulgaria)
  'cz': 'cs-CZ', // Czech (Czech Republic)
  'dk': 'da-DK', // Danish (Denmark)
  'de': 'de-DE', // German (Germany)
  'at': 'de-AT', // German (Austria)
  'ch_de': 'de-CH', // German (Switzerland)
  'lu_de': 'de-LU', // German (Luxembourg)
  'en': 'en-US', // English (United States) - Default Locale
  'au': 'en-AU', // English (Australia)
  'be_en': 'en-BE', // English (Belgium)
  'ca': 'en-CA', // English (Canada)
  'cy_en': 'en-CY', // English (Cyprus)
  'uk': 'en-GB', // English (United Kingdom)
  'gr_en': 'en-GR', // English (Greece)
  'hk_en': 'en-HK', // English (Hong Kong)
  'ie': 'en-IE', // English (Ireland)
  'il_en': 'en-IL', // English (Israel)
  'in': 'en-IN', // English (India)
  'lu_en': 'en-LU', // English (Luxembourg)
  'mt': 'en-MT', // English (Malta)
  'nz': 'en-NZ', // English (New Zealand)
  'africa': 'en-x-AFRICA', // English (Africa)
  'eeurope': 'en-x-EEUROPE', // English (Eastern Europe)
  'mena_en': 'en-x-MENA', // English (Middle East and North Africa)
  'sea': 'en-x-SEA', // English (Southeast Asia)
  'es': 'es-ES', // Spanish (Spain)
  'mx': 'es-MX', // Spanish (Mexico)
  'la': 'es-x-LA', // Spanish (Latin America)
  'ee': 'et-EE', // Estonian (Estonia)
  'fi': 'fi-FI', // Finnish (Finland)
  'fr': 'fr-FR', // French (France)
  'be_fr': 'fr-BE', // French (Belgium)
  'ca_fr': 'fr-CA', // French (Canada)
  'ch_fr': 'fr-CH', // French (Switzerland)
  'lu_fr': 'fr-LU', // French (Luxembourg)
  'il_he': 'he-IL', // Hebrew (Israel)
  'hu': 'hu-HU', // Hungarian (Hungary)
  'it': 'it-IT', // Italian (Italy)
  'ch_it': 'it-CH', // Italian (Switzerland)
  'jp': 'ja-JP', // Japanese (Japan)
  'kr': 'ko-KR', // Korean (Korea)
  'lt': 'lt-LT', // Lithuanian (Lithuania)
  'lv': 'lv-LV', // Latvian (Latvia)
  'no': 'nb-NO', // Norwegian (Norway)
  'nl': 'nl-NL', // Dutch (Netherlands)
  'be_nl': 'nl-BE', // Dutch (Belgium)
  'pl': 'pl-PL', // Polish (Poland)
  'pt': 'pt-PT', // Portuguese (Portugal)
  'br': 'pt-BR', // Portuguese (Brazil)
  'ro': 'ro-RO', // Romanian (Romania)
  'ru': 'ru-RU', // Russian (Russia)
  'cis': 'ru-x-CIS', // Russian (Commonwealth of Independent States)
  'sk': 'sk-SK', // Slovakian (Slovakia)
  'si': 'sl-SI', // Slovenian (Slovenia)
  'se': 'sv-SE', // Swedish (Sweden)
  'tr': 'tr-TR', // Turkish (Turkey)
  'ua': 'uk-UA', // Ukrainian (Ukraine)
  'cn': 'zh-Hans-CN', // Chinese Simplified (China)
  'tw': 'zh-Hant-TW', // Chinese Traditional (Taiwan)    
  'hk_zh': 'zh-Hant-HK' // Chinese Traditional (Hong Kong)
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'bg_BG': 'bg-BG',
  'cs_CZ': 'cs-CZ',
  'da_DK': 'da-DK',
  'de_DE': 'de-DE',
  'en_US': 'en-US',
  'en_AE': 'en-AE',
  'en_GB': 'en-GB',
  'en_IL': 'en-IL',
  'en_XM': 'en-x-MENA',
  'es_ES': 'es-ES',
  'es_LA': 'es-x-LA',
  'es_MX': 'es-MX',
  'es_NA': 'es-x-NA',
  'et_EE': 'et-EE',
  'fi_FI': 'fi-FI',
  'fr_FR': 'fr-FR',
  'fr_CA': 'fr-CA',
  'fr_MA': 'fr-MA',
  'fr_XM': 'fr-x-MENA',
  'hr_HR': 'hr-HR',
  'hu_HU': 'hu-HU',
  'it_IT': 'it-IT',
  'ja_JP': 'ja-JP',
  'ko_KR': 'ko-KR',
  'lt_LT': 'lt-LT',
  'lv_LV': 'lv-LV',
  'nb_NO': 'nb-NO',
  'nl_NL': 'nl-NL',
  'pl_PL': 'pl-PL',
  'pt_BR': 'pt-BR',
  'ro_RO': 'ro-RO',
  'ru_RU': 'ru-RU',
  'sk_SK': 'sk-SK',
  'sl_SI': 'sl-SI',
  'sr_RS': 'sr-RS',
  'sr_SP': 'sr-RS',
  'sv_SE': 'sv-SE',
  'tr_TR': 'tr-TR',
  'uk_UA': 'uk-UA',
  'zh_HANS': 'zh-Hans-CN',
  'zh_CN': 'zh-Hans-CN',
  'zh_HANT': 'zh-Hant-TW',
  'zh_TW': 'zh-Hant-TW'
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'en-GB': 'en-GB',
  'es-ES': 'es-ES',
  'es-MX': 'es-MX',
  'fr-FR': 'fr-FR',
  'fr-CA': 'fr-CA',
  'hu-HU': 'hu-HU',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'nl-NL': 'nl-NL',
  'pt-BR': 'pt-BR',
  'ru-RU': 'ru-RU',
  'sv-SE': 'sv-SE',
  'th-TH': 'th-TH',
  'uk-UA': 'uk-UA',
  'zh-CN': 'zh-Hans-CN',
  'zh-TW': 'zh-Hant-TW'
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'ar_MENA': 'ar-x-MENA',
  'bg_BG': 'bg-BG',
  'cs_CZ': 'cs-CZ',
  'da_DK': 'da-DK',
  'de_DE': 'de-DE',
  'de_AT': 'de-AT',
  'de_CH': 'de-CH',
  'de_LU': 'de-LU',
  'en_US': 'en-US',
  'en_AU': 'en-AU',
  'en_BE': 'en-BE',
  'en_CA': 'en-CA',
  'en_CY': 'en-CY',
  'en_GB': 'en-GB',
  'en_GR': 'en-GR',
  'en_HK': 'en-HK',
  'en_IE': 'en-IE',
  'en_IL': 'en-IL',
  'en_IN': 'en-IN',
  'en_LU': 'en-LU',
  'en_MENA': 'en-x-MENA',
  'en_MT': 'en-MT',
  'en_NZ': 'en-NZ',
  'en_SEA': 'en-x-SEA',
  'en_ZA': 'en-x-AFRICA',
  'es_ES': 'es-ES',
  'es_LA': 'es-x-LA',
  'es_MX': 'es-MX',
  'et_EE': 'et-EE',
  'fi_FI': 'fi-FI',
  'fr_FR': 'fr-FR',
  'fr_BE': 'fr-BE',
  'fr_CA': 'fr-CA',
  'fr_CH': 'fr-CH',
  'fr_LU': 'fr-LU',
  'he_IL': 'he-IL',
  'hu_HU': 'hu-HU',
  'it_CH': 'it-CH',
  'it_IT': 'it-IT',
  'ja_JP': 'ja-JP',
  'ko_KR': 'ko-KR',
  'lt_LT': 'lt-LT',
  'lv_LV': 'lv-LV',
  'nb_NO': 'nb-NO',
  'nl_BE': 'nl-BE',
  'nl_NL': 'nl-NL',
  'pl_PL': 'pl-PL',
  'pt_BR': 'pt-BR',
  'pt_PT': 'pt-PT',
  'ro_RO': 'ro-RO',
  'ru_RU': 'ru-RU',
  'sk_SK': 'sk-SK',
  'sl_SI': 'sl-SI',
  'sv_SE': 'sv-SE',
  'tr_TR': 'tr-TR',
  'uk_UA': 'uk-UA',
  'zh_CN': 'zh-Hans-CN',
  'zh_TW': 'zh-Hant-TW',
  'zh_HK': 'zh-Hant-HK'
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'ar_AE': 'ar-AE',
  'bg_BG': 'bg-BG',
  'cs_CZ': 'cs-CZ',
  'da_DK': 'da-DK',
  'de_DE': 'de-DE',
  'en_US': 'en-US',
  'en_GB': 'en-GB',
  'en_HK': 'en-HK',
  'en_IL': 'en-IL',
  'es_ES': 'es-ES',
  'es_MX': 'es-MX',
  'et_EE': 'et-EE',
  'fi_FI': 'fi-FI',
  'fr_FR': 'fr-FR',
  'fr_CA': 'fr-CA',
  'he_IL': 'he-IL',
  'hr_HR': 'hr-HR',
  'hu_HU': 'hu-HU',
  'it_IT': 'it-IT',
  'ja_JP': 'ja-JP',
  'ko_KR': 'ko-KR',
  'lt_LT': 'lt-LT',
  'lv_LV': 'lv-LV',
  'nb_NO': 'nb-NO',
  'nl_NL': 'nl-NL',
  'pl_PL': 'pl-PL',
  'pt_BR': 'pt-BR',
  'ro_RO': 'ro-RO',
  'ru_RU': 'ru-RU',
  'sk_SK': 'sk-SK',
  'sl_SI': 'sl-SI',
  'sr_RS': 'sr-Latn-RS',
  'sv_SE': 'sv-SE',
  'tr_TR': 'tr-TR',
  'uk_UA': 'uk-UA',
  'zh_CN': 'zh-Hans-CN',
  'zh_HK': 'zh-Hant-HK',
  'zh_TW': 'zh-Hant-TW'
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'ar_AE': 'ar-AE',
  'bg_BG': 'bg-BG',
  'ca_ES': 'ca-ES',
  'cs_CZ': 'cs-CZ',
  'da_DK': 'da-DK',
  'de_DE': 'de-DE',
  'el_GR': 'el-GR',
  'en_US': 'en-US',
  'es_ES': 'es-ES',
  'et_EE': 'et-EE',
  'fa_IR': 'fa-IR',
  'fi_FI': 'fi-FI',
  'fr_FR': 'fr-FR',
  'he_IL': 'he-IL',
  'hi_IN': 'hi-IN',
  'ht_HT': 'ht-HT',
  'hu_HU': 'hu-HU',
  'id_ID': 'id-ID',
  'it_IT': 'it-IT',
  'ja_JP': 'ja-JP',
  'ko_KR': 'ko-KR',
  'lt_LT': 'lt-LT',
  'lv_LV': 'lv-LV',
  'ms_MY': 'ms-MY',
  'nl_NL': 'nl-NL',
  'no_NO': 'nb-NO',
  'pl_PL': 'pl-PL',
  'pt_BR': 'pt-BR',
  'ro_RO': 'ro-RO',
  'ru_RU': 'ru-RU',
  'sk_SK': 'sk-SK',
  'sl_SI': 'sl-SI',
  'sv_SE': 'sv-SE',
  'th_TH': 'th-TH',
  'tr_TR': 'tr-TR',
  'uk_UA': 'uk-UA',
  'ur_PK': 'ur-PK',
  'vi_VN': 'vi-VN',
  'zh_CN': 'zh-Hans-CN',
  'zh_TW': 'zh-Hant-TW'
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs_CZ': 'cs-CZ',
  'da_DK': 'da-DK',
  'de_DE': 'de-DE',
  'en_US': 'en-US',
  'en_GB': 'en-GB',
  'en_IL': 'en-IL',
  'en_AE': 'en-AE',
  'en_XM': 'en-x-MENA',
  'es_ES': 'es-ES',
  'es_MX': 'es-MX',
  'es_LA': 'es-x-LA',
  'es_NA': 'es-x-NA',
  'fi_FI': 'fi-FI',
  'fr_FR': 'fr-FR',
  'fr_CA': 'fr-CA',
  'fr_MA': 'fr-MA',
  'fr_XM': 'fr-x-MENA',
  'it_IT': 'it-IT',
  'ja_JP': 'ja-JP',
  'ko_KR': 'ko-KR',
  'nb_NO': 'nb-NO',
  'nl_NL': 'nl-NL',
  'pl_PL': 'pl-PL',
  'pt_BR': 'pt-BR',
  'ru_RU': 'ru-RU',
  'sv_SE': 'sv-SE',
  'tr_TR': 'tr-TR',
  'hu_HU': 'hu-HU',
  'sk_SK': 'sk-SK',
  'sl_SI': 'sl-SI',
  'uk_UA': 'uk-UA',
  'zh_CN': 'zh-Hans-CN',
  'zh_TW': 'zh-Hant-TW'
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'at/de': 'de-AT',
  'au/en': 'en-AU',
  'be/en': 'en-BE',
  'be/fr': 'fr-BE',
  'be/nl': 'nl-BE',
  'bg/en': 'en-BG',
  'br/pt': 'pt-BR',
  'ca/en': 'en-CA',
  'ca/fr': 'fr-CA',
  'ch/de': 'de-CH',
  'ch/fr': 'fr-CH',
  'ch/it': 'it-CH',
  'cn/zh-Hans': 'zh-Hans-CN',
  'cy/en': 'en-CY',
  'cz/cs': 'cs-CZ',
  'de/de': 'de-DE',
  'dk/da': 'da-DK',
  'ee/en': 'en-EE',
  'es/es': 'es-ES',
  'fi/fi': 'fi-FI',
  'fr/fr': 'fr-FR',
  'gr/en': 'en-GR',
  'hk/en': 'en-HK',
  'hk/zh-Hant': 'zh-Hant-HK',
  'hu/hu': 'hu-HU',
  'ie/en': 'en-IE',
  'il/en': 'en-IL',
  'in/en': 'en-IN',
  'it/it': 'it-IT',
  'jp/ja': 'ja-JP',
  'kr/ko': 'ko-KR',
  'la/es': 'es-x-LA',
  'lt/en': 'en-LT',
  'lu/de': 'de-LU',
  'lu/en': 'en-LU',
  'lu/fr': 'fr-LU',
  'lv/en': 'en-LV',
  'mena/en': 'en-x-MENA',
  'mt/en': 'en-MT',
  'mx/es': 'es-MX',
  'nl/nl': 'nl-NL',
  'no/no': 'nb-NO',
  'nz/en': 'en-NZ',
  'pl/pl': 'pl-PL',
  'pt/pt': 'pt-PT',
  'ro/en': 'en-RO',
  'ru/ru': 'ru-RU',
  'se/sv': 'sv-SE',
  'sea/en': 'en-x-SEA',
  'si/en': 'en-SI',
  'sk/en': 'en-SK',
  'tr/tr': 'tr-TR',
  'tw/zh-Hant': 'zh-Hant-TW',
  'ua/en': 'en-UA',
  'uk/en': 'en-GB',
  'us/en': 'en-US',
  'za/en': 'en-x-AFRICA'
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs-CZ': 'cs-CZ',
  'da-DK': 'da-DK',
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'fi-FI': 'fi-FI',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'nb-NO': 'nb-NO',
  'nl-NL': 'nl-NL',
  'pl-PL': 'pl-PL',
  'pt-BR': 'pt-BR',
  'pt-PT': 'pt-PT',
  'ru-RU': 'ru-RU',
  'sv-SE': 'sv-SE',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'uk-UA': 'uk-UA',
  'zh-CN': 'zh-Hans-CN',
  'zh-HK': 'zh-Hant-HK',
  'zh-TW': 'zh-Hant-TW'
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  en_us: 'en-US', // English (United States)
  en_au: 'en-AU', // English (Australia)
  en_be: 'en-BE', // English (Belgium)
  en_br: 'en-BR', // English (Brazil)
  en_ca: 'en-CA', // English (Canada)
  en_cis: 'en-x-CIS', // English (Commonwealth of Independent States)
  en_cy: 'en-CY', // English (Cyprus)
  en_gb: 'en-GB', // English (United Kingdom)
  en_gr: 'en-GR', // English (Greece)
  en_il: 'en-IL', // English (Israel)
  en_ie: 'en-IE', // English (Ireland)
  en_in: 'en-IN', // English (India)
  en_hk: 'en-HK', // English (Hong Kong)
  en_lu: 'en-LU', // English (Luxembourg)
  en_mena: 'en-x-MENA', // English (Middle East and North Africa)
  en_mt: 'en-MT', // English (Malta)
  en_nz: 'en-NZ', // English (New Zealand)
  en_sea: 'en-x-SEA', // English (Southeast Asia)
  en_za: 'en-ZA', // English (South Africa)
  cs_cz: 'cs-CZ', // Czech (Czech Republic)
  da_dk: 'da-DK', // Danish (Denmark)
  de_de: 'de-DE', // German (Germany)
  de_ch: 'de-CH', // German (Switzerland)
  de_lu: 'de-LU', // German (Luxembourg)
  es_es: 'es-ES', // Spanish (Spain)
  es_419: 'es-x-LA', // Spanish (Latin America)
  es_mx: 'es-MX', // Spanish (Mexico)
  fr_fr: 'fr-FR', // French (France)
  fi_fi: 'fi-FI', // Finnish (Finland)
  fr_ca: 'fr-CA', // French (Canada)
  fr_ch: 'fr-CH', // French (Switzerland)
  fr_be: 'fr-BE', // French (Belgium)
  fr_mena: 'fr-x-MENA', // French (Middle East and North Africa)
  fr_lu: 'fr-LU', // French (Luxembourg)
  it_it: 'it-IT', // Italian (Italy)
  it_ch: 'it-CH', // Italian (Switzerland)
  ja_jp: 'ja-JP', // Japanese (Japan)
  ko_kr: 'ko-KR', // Korean (Korea)
  nb_no: 'nb-NO', // Norwegian (Norway)
  nl_nl: 'nl-NL', // Dutch (Netherlands)
  pl_pl: 'pl-PL', // Polish (Poland)
  pt_pt: 'pt-PT', // Portuguese (Portugal)
  pt_br: 'pt-BR', // Portuguese (Brazil)
  ru_ru: 'ru-RU', // Russian (Russia)
  sv_se: 'sv-SE', // Swedish (Sweden)
  tr_tr: 'tr-TR', // Turkish (Turkey)
  zh_cn: 'zh-Hans-CN', // Chinese Simplified (China)
  zh_tw: 'zh-Hant-TW' // Chinese Traditional (Taiwan)
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'zh-tw': 'zh-Hant-TW'
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'ar-AE': 'ar-AE',
  'bg-BG': 'bg-BG',
  'cs-CZ': 'cs-CZ',
  'da-DK': 'da-DK',
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'et-EE': 'et-EE',
  'fi-FI': 'fi-FI',
  'fr-FR': 'fr-FR',
  'he-IL': 'he-IL',
  'hr-HR': 'hr-HR',
  'hu-HU': 'hu-HU',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'lt-LT': 'lt-LT',
  'lv-LV': 'lv-LV',
  'nb-NO': 'nb-NO',
  'nl-NL': 'nl-NL',
  'pl-PL': 'pl-PL',
  'pt-BR': 'pt-BR',
  'ro-RO': 'ro-RO',
  'ru-RU': 'ru-RU',
  'sk-SK': 'sk-SK',
  'sl-SI': 'sl-SI',
  'sr-SP': 'sr-Latn-RS',
  'sv-SE': 'sv-SE',
  'tr-TR': 'tr-TR',
  'uk-UA': 'uk-UA',
  'zh-CN': 'zh-Hans-CN',
  'zh-TW': 'zh-Hant-TW'
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'zh-hans': 'zh-Hans-CN',
  'zh-hant': 'zh-Hant-TW'
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cy-GB': 'cy-GB',
  'en-US': 'en-US',
  'de-DE': 'de-DE',
  'fr-FR': 'fr-FR',
  'es-ES': 'es-ES',
  'it-IT': 'it-IT',
  'pt-BR': 'pt-BR',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'nb-NO': 'nb-NO',
  'da-DK': 'da-DK',
  'nl-NL': 'nl-NL',
  'sv-SE': 'sv-SE',
  'fi-FI': 'fi-FI',
  'zh-Hans-CN': 'zh-Hans-CN',
  'zh-Hant-TW': 'zh-Hant-TW'
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'bg': 'bg-BG',
  'cz': 'cs-CZ',
  'dk': 'da-DK',
  'de': 'de-DE',
  'at': 'de-AT',
  'ch_de': 'de-CH',
  'lu_de': 'de-LU',
  'gr_en': 'el-GR',
  'cy_en': 'el-CY',
  'us': 'en-US',
  'be_en': 'en-BE',
  'ca': 'en-CA',
  'au': 'en-AU',
  'uk': 'en-GB',
  'ie': 'en-IE',
  'lu_en': 'en-LU',
  'nz': 'en-NZ',
  'ph': 'en-PH',
  'sg': 'en-SG',
  'es': 'es-ES',
  'ar': 'es-AR',
  'cl': 'es-CL',
  'co': 'es-CO',
  'cr': 'es-CR',
  'ec': 'es-EC',
  'gt': 'es-GT',
  'mx': 'es-MX',
  'pe': 'es-PE',
  've': 'es-VE',
  'ee': 'et-EE',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'be_fr': 'fr-BE',
  'ca_fr': 'fr-CA',
  'ch_fr': 'fr-CH',
  'lu_fr': 'fr-LU',
  'il': 'he-IL',
  'in': 'hi-IN',
  'hu': 'hu-HU',
  'it': 'it-IT',
  'ch_it': 'it-CH',
  'jp': 'ja-JP',
  'kr': 'ko-KR',
  'lt': 'lt-LT',
  'lv': 'lv-LV',
  'mt': 'mt-MT',
  'no': 'nb-NO',
  'nl': 'nl-NL',
  'be_nl': 'nl-BE',
  'pl': 'pl-PL',
  'pt': 'pt-PT',
  'br': 'pt-BR',
  'ro': 'ro-RO',
  'ru': 'ru-RU',
  'sk': 'sk-SK',
  'si': 'sl-SI',
  'se': 'sv-SE',
  'th': 'th-TH',
  'ua': 'uk-UA',
  'tw': 'zh-Hant-TW',
  'hk': 'zh-Hant-HK'
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'fr-FR': 'fr-FR',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'pt-BR': 'pt-BR',
  'ru-RU': 'ru-RU',
  'zh-CN': 'zh-Hans-CN',
  'zh-TW': 'zh-Hant-TW'
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'no': 'nb-NO',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'zh-tw': 'zh-Hant-TW'
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'hu': 'hu-HU',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'uk': 'uk-UA',
  'zh-Hans': 'zh-Hans-CN',
  'zh-Hant': 'zh-Hant-TW'
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs_CZ': 'cs-CZ',
  'da_DK': 'da-DK',
  'de_DE': 'de-DE',
  'de_LU': 'de-LU',
  'el_GR': 'el-GR',
  'en_US': 'en-US',
  'en_GB': 'en-GB',
  'es_ES': 'es-ES',
  'et_EE': 'et-EE',
  'fi_FI': 'fi-FI',
  'fr_FR': 'fr-FR',
  'fr_CA': 'fr-CA',
  'hu_HU': 'hu-HU',
  'it_IT': 'it-IT',
  'ja_JP': 'ja-JP',
  'ko_KR': 'ko-KR',
  'nb_NO': 'nb-NO',
  'nl_NL': 'nl-NL',
  'pl_PL': 'pl-PL',
  'pt_BR': 'pt-BR',
  'pt_PT': 'pt-PT',
  'ro_RO': 'ro-RO',
  'ru_RU': 'ru-RU',
  'sv_SE': 'sv-SE',
  'tr_TR': 'tr-TR',
  'uk_UA': 'uk-UA',
  'zh_CN': 'zh-Hans-CN',
  'zh_TW': 'zh-Hant-TW'
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs_CZ': 'cs-CZ',
  'da_DK': 'da-DK',
  'de_DE': 'de-DE',
  'en_US': 'en-US',
  'es_ES': 'es-ES',
  'fi_FI': 'fi-FI',
  'fr_FR': 'fr-FR',
  'it_IT': 'it-IT',
  'ja_JP': 'ja-JP',
  'ko_KR': 'ko-KR',
  'nb_NO': 'nb-NO',
  'nl_NL': 'nl-NL',
  'pl_PL': 'pl-PL',
  'pt_PT': 'pt-PT',
  'pt_BR': 'pt-BR',
  'ru_RU': 'ru-RU',
  'sv_SE': 'sv-SE',
  'tr_TR': 'tr-TR',
  'uk_UA': 'uk-UA',
  'zh_CN': 'zh-Hans-CN',
  'zh_TW': 'zh-Hant-TW'
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs_CZ': 'cs-CZ',
  'da_DK': 'da-DK',
  'de_DE': 'de-DE',
  'en_US': 'en-US',
  'en_AE': 'en-AE',
  'en_GB': 'en-GB',
  'en_IL': 'en-IL',
  'es_ES': 'es-ES',
  'es_MX': 'es-MX',
  'fi_FI': 'fi-FI',
  'fr_FR': 'fr-FR',
  'fr_CA': 'fr-CA',
  'fr_MA': 'fr-MA',
  'hu_HU': 'hu-HU',
  'it_IT': 'it-IT',
  'ja_JP': 'ja-JP',
  'ko_KR': 'ko-KR',
  'nb_NO': 'nb-NO',
  'nl_NL': 'nl-NL',
  'pl_PL': 'pl-PL',
  'pt_BR': 'pt-BR',
  'ru_RU': 'ru-RU',
  'sv_SE': 'sv-SE',
  'tr_TR': 'tr-TR',
  'uk_UA': 'uk-UA',
  'zh_CN': 'zh-Hans-CN',
  'zh_TW': 'zh-Hant-TW'
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'fr-FR': 'fr-FR',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'pt-BR': 'pt-BR',
  'ru-RU': 'ru-RU'
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'au': 'en-AU', // English (Australia)
  'nz': 'en-NZ' // English (New Zealand)
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'bg': 'bg-BG', // Bulgarian (Bulgaria)
  'cz': 'cs-CZ', // Czech (Czech Republic)
  'dk': 'da-DK', // Danish (Denmark)
  'de': 'de-DE', // German (Germany)
  'at': 'de-AT', // German (Austria)
  'ch_de': 'de-CH', // German (Switzerland)
  'lu_de': 'de-LU', // German (Luxembourg)
  'us': 'en-US', // English (United States) - Default Locale
  'au': 'en-AU', // English (Australia)
  'be_en': 'en-BE', // English (Belgium)
  'ca': 'en-CA', // English (Canada)
  'cy_en': 'en-CY', // English (Cyprus)
  'uk': 'en-GB', // English (United Kingdom)
  'gr_en': 'en-GR', // English (Greece)
  'hk_en': 'en-HK', // English (Hong Kong)
  'ie': 'en-IE', // English (Ireland) 
  'lu_en': 'en-LU', // English (Luxembourg)
  'mt': 'en-MT', // English (Malta)
  'nz': 'en-NZ', // English (New Zealand)
  'africa': 'en-x-AFRICA', // English (Africa)
  'es': 'es-ES', // Spanish (Spain)
  'mx': 'es-MX', // Spanish (Mexico)
  'ee': 'et-EE', // Estonian (Estonia)
  'fi': 'fi-FI', // Finnish (Finland)
  'fr': 'fr-FR', // French (France)
  'be_fr': 'fr-BE', // French (Belgium)
  'ca_fr': 'fr-CA', // French (Canada)
  'ch_fr': 'fr-CH', // French (Switzerland)
  'lu_fr': 'fr-LU', // French (Luxembourg)
  'hu': 'hu-HU', // Hungarian (Hungary)
  'it': 'it-IT', // Italian (Italy)
  'ch_it': 'it-CH', // Italian (Switzerland)
  'jp': 'ja-JP', // Japanese (Japan)
  'kr': 'ko-KR', // Korean (Korea)
  'lt': 'lt-LT', // Lithuanian (Lithuania)
  'lv': 'lv-LV', // Latvian (Latvia)
  'no': 'nb-NO', // Norwegian (Norway)
  'nl': 'nl-NL', // Dutch (Netherlands)
  'be_nl': 'nl-BE', // Dutch (Belgium)
  'pl': 'pl-PL', // Polish (Poland)
  'pt': 'pt-PT', // Portuguese (Portugal)
  'br': 'pt-BR', // Portuguese (Brazil)
  'ro': 'ro-RO', // Romanian (Romania)
  'ru': 'ru-RU', // Russian (Russia)
  'sk': 'sk-SK', // Slovakian (Slovakia)
  'si': 'sl-SI', // Slovenian (Slovenia)
  'se': 'sv-SE', // Swedish (Sweden) 
  'hk_zh': 'zh-Hant-HK' // Chinese Traditional (Hong Kong)   
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'mena_ar': 'ar-x-MENA', // Arabic (Middle East and North Africa)
  'bg': 'bg-BG', // Bulgarian (Bulgaria)
  'cz': 'cs-CZ', // Czech (Czech Republic)
  'dk': 'da-DK', // Danish (Denmark)
  'de': 'de-DE', // German (Germany)
  'at': 'de-AT', // German (Austria)
  'ch_de': 'de-CH', // German (Switzerland)
  'lu_de': 'de-LU', // German (Luxembourg)
  'us': 'en-US', // English (United States) - Default Locale
  'au': 'en-AU', // English (Australia)
  'be_en': 'en-BE', // English (Belgium)
  'ca': 'en-CA', // English (Canada)
  'cy_en': 'en-CY', // English (Cyprus)
  'uk': 'en-GB', // English (United Kingdom)
  'gr_en': 'en-GR', // English (Greece)
  'hk_en': 'en-HK', // English (Hong Kong)
  'ie': 'en-IE', // English (Ireland)
  'il_en': 'en-IL', // English (Israel)
  'in': 'en-IN', // English (India)
  'lu_en': 'en-LU', // English (Luxembourg)
  'mt': 'en-MT', // English (Malta)
  'nz': 'en-NZ', // English (New Zealand)
  'africa': 'en-x-AFRICA', // English (Africa)
  'cis_en': 'en-x-CIS', // English (Commonwealth of Independent States)
  'mena_en': 'en-x-MENA', // English (Middle East and North Africa)
  'sea': 'en-x-SEA', // English (Southeast Asia)
  'sg': 'en-x-SEA', // English (Singapore -> redirect to 'sea')
  'es': 'es-ES', // Spanish (Spain)
  'mx': 'es-MX', // Spanish (Mexico)
  'la': 'es-x-LA', // Spanish (Latin America)
  'ee': 'et-EE', // Estonian (Estonia)
  'fi': 'fi-FI', // Finnish (Finland)
  'fr': 'fr-FR', // French (France)
  'be_fr': 'fr-BE', // French (Belgium)
  'ca_fr': 'fr-CA', // French (Canada)
  'ch_fr': 'fr-CH', // French (Switzerland)
  'lu_fr': 'fr-LU', // French (Luxembourg)
  'il_he': 'he-IL', // Hebrew (Israel)
  'hu': 'hu-HU', // Hungarian (Hungary)
  'it': 'it-IT', // Italian (Italy)
  'ch_it': 'it-CH', // Italian (Switzerland)
  'jp': 'ja-JP', // Japanese (Japan)
  'kr': 'ko-KR', // Korean (Korea)
  'lt': 'lt-LT', // Lithuanian (Lithuania)
  'lv': 'lv-LV', // Latvian (Latvia)
  'no': 'nb-NO', // Norwegian (Norway)
  'nl': 'nl-NL', // Dutch (Netherlands)
  'be_nl': 'nl-BE', // Dutch (Belgium)
  'pl': 'pl-PL', // Polish (Poland)
  'pt': 'pt-PT', // Portuguese (Portugal)
  'br': 'pt-BR', // Portuguese (Brazil)
  'ro': 'ro-RO', // Romanian (Romania)
  'ru': 'ru-RU', // Russian (Russia)
  'cis_ru': 'ru-x-CIS', // Russian (Commonwealth of Independent States)
  'sk': 'sk-SK', // Slovakian (Slovakia)
  'si': 'sl-SI', // Slovenian (Slovenia)
  'se': 'sv-SE', // Swedish (Sweden)
  'tr': 'tr-TR', // Turkish (Turkey)
  'ua': 'uk-UA', // Ukrainian (Ukraine)
  'cn': 'zh-Hans-CN', // Chinese Simplified (China)
  'tw': 'zh-Hant-TW', // Chinese Traditional (Taiwan) 
  'hk_zh': 'zh-Hant-HK' // Chinese Traditional (Hong Kong)   
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'uk': 'uk-UA',
  'pt': 'pt-BR',
  'ar-mena': 'ar-x-MENA',
  'en-africa': 'en-x-AFRICA',
  'en-cis': 'en-x-CIS',
  'en-mena': 'en-x-MENA',
  'en-sea': 'en-x-SEA',
  'es-la': 'es-x-LA',
  'ru-cis': 'ru-x-CIS',
  'zh': 'zh-Hans-CN'
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'AF': [], // Afghanistan
  'AX': [], // Aland Islands
  'AL': [], // Albania
  'DZ': ['en', 'fr', 'ar'], // Algeria
  'AS': [], // American Samoa
  'AD': ['es', 'fr', 'pt'], // Andorra
  'AO': ['pt'], // Angola
  'AI': [], // Anguilla
  'AQ': ['en'], // Antarctica
  'AG': ['en'], // Antigua And Barbuda
  'AR': ['es'], // Argentina
  'AM': ['en', 'ru'], // Armenia
  'AW': [], // Aruba
  'AU': ['en'], // Australia
  'AT': ['de'], // Austria
  'AZ': ['en', 'ru'], // Azerbaijan
  'BS': ['en'], // Bahamas
  'BH': ['ar', 'en'], // Bahrain
  'BD': [], // Bangladesh
  'BB': ['en'], // Barbados
  'BY': ['ru'], // Belarus
  'BE': ['nl', 'en', 'fr'], // Belgium
  'BZ': [], // Belize
  'BJ': [], // Benin
  'BM': ['en'], // Bermuda
  'BT': [], // Bhutan
  'BO': ['es'], // Bolivia
  'BA': ['en'], // Bosnia And Herzegovina
  'BW': ['en'], // Botswana
  'BV': [], // Bouvet Island
  'BR': ['pt'], // Brazil
  'IO': [], // British Indian Ocean Territory
  'BN': ['en'], // Brunei Darussalam
  'BG': ['bg'], // Bulgaria
  'BF': [], // Burkina Faso
  'BI': ['en', 'fr'], // Burundi
  'KH': [], // Cambodia
  'CM': ['en', 'fr'], // Cameroon
  'CA': ['en', 'fr'], // Canada
  'CV': [], // Cape Verde
  'KY': ['en'], // Cayman Islands
  'CF': [], // Central African Republic
  'TD': [], // Chad
  'CL': ['es'], // Chile
  'CN': ['zh-Hans'], // China
  'CX': [], // Christmas Island
  'CC': ['en'], // Cocos (Keeling) Islands
  'CO': ['es'], // Colombia
  'KM': [], // Comoros
  'CG': ['en', 'fr'], // Congo
  'CD': ['en', 'fr'], // Congo, Democratic Republic
  'CK': [], // Cook Islands
  'CR': ['es'], // Costa Rica
  'CI': ['en', 'fr'], // Cote D'Ivoire
  'HR': ['en'], // Croatia
  'CU': [], // Cuba
  'CY': ['en'], // Cyprus
  'CZ': ['cs'], // Czech Republic
  'DK': ['da'], // Denmark
  'DJ': [], // Djibouti
  'DM': ['en'], // Dominica
  'DO': ['es'], // Dominican Republic
  'EC': ['es'], // Ecuador
  'EG': ['ar', 'en'], // Egypt
  'SV': ['es'], // El Salvador
  'GQ': [], // Equatorial Guinea
  'ER': [], // Eritrea
  'EE': ['et'], // Estonia
  'ET': [], // Ethiopia
  'FK': [], // Falkland Islands (Malvinas)
  'FO': ['da'], // Faroe Islands
  'FJ': [], // Fiji
  'FI': ['fi'], // Finland
  'FR': ['fr'], // France
  'GF': ['fr'], // French Guiana
  'PF': [], // French Polynesia
  'TF': [], // French Southern Territories
  'GA': [], // Gabon
  'GM': [], // Gambia
  'GE': ['en', 'ru'], // Georgia
  'DE': ['de'], // Germany
  'GH': ['en'], // Ghana
  'GI': [], // Gibraltar
  'GR': ['en'], // Greece
  'GL': [], // Greenland
  'GD': [], // Grenada
  'GP': ['en', 'fr'], // Guadeloupe
  'GU': [], // Guam
  'GT': ['es'], // Guatemala
  'GG': [], // Guernsey
  'GN': [], // Guinea
  'GW': [], // Guinea-Bissau
  'GY': ['en'], // Guyana
  'HT': ['en', 'fr'], // Haiti
  'HM': [], // Heard Island & Mcdonald Islands
  'VA': [], // Holy See (Vatican City State)
  'HN': ['es'], // Honduras
  'HK': ['en', 'zh-Hant'], // Hong Kong
  'HU': ['hu'], // Hungary
  'IS': [], // Iceland
  'IN': ['en'], // India
  'ID': ['en'], // Indonesia
  'IR': [], // Iran, Islamic Republic Of
  'IQ': ['ar'], // Iraq
  'IE': ['en'], // Ireland
  'IM': [], // Isle Of Man
  'IL': ['he', 'en'], // Israel
  'IT': ['it'], // Italy
  'JM': ['en'], // Jamaica
  'JP': ['ja'], // Japan
  'JE': [], // Jersey
  'JO': ['ar', 'en'], // Jordan
  'KZ': ['ru'], // Kazakhstan
  'KE': ['en'], // Kenya
  'KI': [], // Kiribati
  'KR': ['ko'], // Korea
  'KV': [], // Kosovo
  'KW': ['ar', 'en'], // Kuwait
  'KG': ['ru', 'en'], // Kyrgyzstan
  'LA': [], // Lao People\'s Democratic Republic
  'LV': ['lv'], // Latvia
  'LB': ['en', 'ar'], // Lebanon
  'LS': ['en'], // Lesotho
  'LR': ['en'], // Liberia
  'LY': ['ar'], // Libyan Arab Jamahiriya
  'LI': [], // Liechtenstein
  'LT': ['lt'], // Lithuania
  'LU': ['en', 'de', 'fr'], // Luxembourg
  'MO': ['en', 'zh-Hant'], // Macao
  'MK': [], // Macedonia
  'MG': ['en', 'fr'], // Madagascar
  'MW': [], // Malawi
  'MY': ['en'], // Malaysia
  'MV': [], // Maldives
  'ML': ['en', 'fr'], // Mali
  'MT': ['en'], // Malta
  'MH': [], // Marshall Islands
  'MQ': ['en', 'fr'], // Martinique
  'MR': ['en', 'fr'], // Mauritania
  'MU': ['en', 'fr'], // Mauritius
  'YT': ['en', 'fr'], // Mayotte
  'MX': ['es'], // Mexico
  'FM': ['en'], // Micronesia, Federated States Of
  'MD': ['en', 'ru'], // Moldova
  'MC': [], // Monaco
  'MN': [], // Mongolia
  'ME': [], // Montenegro
  'MS': [], // Montserrat
  'MA': ['en', 'fr', 'ar'], // Morocco
  'MZ': ['pt'], // Mozambique
  'MM': [], // Myanmar
  'NA': ['en'], // Namibia
  'NR': [], // Nauru
  'NP': [], // Nepal
  'NL': ['nl'], // Netherlands
  'AN': ['nl', 'en'], // Netherlands Antilles
  'NC': [], // New Caledonia
  'NZ': ['en'], // New Zealand
  'NI': ['es'], // Nicaragua
  'NE': ['en', 'fr'], // Niger
  'NG': ['en'], // Nigeria
  'NU': [], // Niue
  'NF': [], // Norfolk Island
  'MP': ['en'], // Northern Mariana Islands
  'NO': ['nb'], // Norway
  'OM': ['ar', 'en'], // Oman
  'PK': ['en'], // Pakistan
  'PW': [], // Palau
  'PS': [], // Palestinian Territory, Occupied
  'PA': ['es'], // Panama
  'PG': [], // Papua New Guinea
  'PY': ['es'], // Paraguay
  'PE': ['es'], // Peru
  'PH': ['en'], // Philippines
  'PN': [], // Pitcairn
  'PL': ['pl'], // Poland
  'PT': ['pt'], // Portugal
  'PR': ['es'], // Puerto Rico
  'QA': ['ar', 'en'], // Qatar
  'RE': [], // Reunion
  'RO': ['ro'], // Romania
  'RU': ['ru'], // Russian Federation
  'RW': [], // Rwanda
  'BL': [], // Saint Barthelemy
  'SH': [], // Saint Helena
  'KN': ['en'], // Saint Kitts And Nevis
  'LC': ['en'], // Saint Lucia
  'MF': [], // Saint Martin
  'PM': [], // Saint Pierre And Miquelon
  'VC': ['pt'], // Saint Vincent And Grenadines
  'WS': [], // Samoa
  'SM': [], // San Marino
  'ST': [], // Sao Tome And Principe
  'SA': ['ar', 'en'], // Saudi Arabia
  'SN': ['en', 'fr'], // Senegal
  'RS': ['rs'], // Serbia
  'SC': [], // Seychelles
  'SL': [], // Sierra Leone
  'SG': ['en'], // Singapore
  'SK': ['sk'], // Slovakia
  'SI': ['sl'], // Slovenia
  'SB': [], // Solomon Islands
  'SO': [], // Somalia
  'ZA': ['en'], // South Africa
  'GS': [], // South Georgia And Sandwich Isl.
  'ES': ['es'], // Spain
  'LK': ['en'], // Sri Lanka
  'SD': [], // Sudan
  'SR': ['nl'], // Suriname
  'SJ': [], // Svalbard And Jan Mayen
  'SZ': [], // Swaziland
  'SE': ['sv'], // Sweden
  'CH': ['de', 'fr', 'it'], // Switzerland
  'SY': [], // Syrian Arab Republic
  'TW': ['zh-Hant'], // Taiwan
  'TJ': ['ru', 'en'], // Tajikistan
  'TZ': ['en'], // Tanzania
  'TH': ['en'], // Thailand
  'TL': [], // Timor-Leste
  'TG': [], // Togo
  'TK': [], // Tokelau
  'TO': [], // Tonga
  'TT': ['en'], // Trinidad And Tobago
  'TN': ['en', 'fr', 'ar'], // Tunisia
  'TR': ['tr'], // Turkey
  'TM': ['en', 'ru'], // Turkmenistan
  'TC': ['en'], // Turks And Caicos Islands
  'TV': [], // Tuvalu
  'UG': ['en'], // Uganda
  'UA': ['uk'], // Ukraine
  'AE': ['en', 'ar'], // United Arab Emirates
  'GB': ['en'], // United Kingdom
  'US': ['en'], // United States
  'UM': [], // United States Outlying Islands
  'UY': ['es'], // Uruguay
  'UZ': ['ru', 'en'], // Uzbekistan
  'VU': [], // Vanuatu
  'VE': ['es'], // Venezuela
  'VN': ['en'], // Viet Nam
  'VG': ['en'], // Virgin Islands, British
  'VI': [], // Virgin Islands, U.S.
  'WF': [], // Wallis And Futuna
  'EH': [], // Western Sahara
  'YE': ['en', 'ar'], // Yemen
  'ZM': ['en'], // Zambia
  'ZW': ['en'] // Zimbabwe
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _locales = __webpack_require__(2);

var locales = _interopRequireWildcard(_locales);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/*
 * @param {string} app - app code. For a complete apps code, see https://git.corp.adobe.com/intl/adobe-locales#supported-apps
 * @returns {array} app supported locale codes. Returns undefined if passed locale is not supported in the app. 
 */
var getAppLocales = function getAppLocales(app) {
  return locales[app] && Object.keys(locales[app]);
}; /*************************************************************************
   * ADOBE CONFIDENTIAL
   * ___________________
   *
   *  Copyright 2018 Adobe Systems Incorporated
   *  All Rights Reserved.
   *
   * NOTICE:  All information contained herein is, and remains
   * the property of Adobe Systems Incorporated and its suppliers,
   * if any.  The intellectual and technical concepts contained
   * herein are proprietary to Adobe Systems Incorporated and its
   * suppliers and are protected by all applicable intellectual property
   * laws, including trade secret and copyright laws.
   * Dissemination of this information or reproduction of this material
   * is strictly forbidden unless prior written permission is obtained
   * from Adobe Systems Incorporated.
   **************************************************************************/

exports.default = getAppLocales;

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getLocalizedURL = __webpack_require__(5);

var _getLocalizedURL2 = _interopRequireDefault(_getLocalizedURL);

var _getAppLocaleFromIMS2 = __webpack_require__(4);

var _getAppLocaleFromIMS3 = _interopRequireDefault(_getAppLocaleFromIMS2);

var _utils = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * @param {string} url - the destination app url
 * @param {string} locale - locale you want to pass, it doesn not have to be the one destination app uses.
 * @param {string} imsCountryCode - two-character IMS country code
 * @returns {{url: string, match: boolean}}
 */
var getLocalizedURLFromIMS = function getLocalizedURLFromIMS(url, locale, imsCountryCode) {
  var app = (0, _utils.getAppNameFromURL)(url);

  var _getAppLocaleFromIMS = (0, _getAppLocaleFromIMS3.default)(app, locale, imsCountryCode),
      newLocale = _getAppLocaleFromIMS.locale,
      match = _getAppLocaleFromIMS.match;

  return {
    match: match,
    url: (0, _getLocalizedURL2.default)(url, newLocale)
  };
}; /*************************************************************************
   * ADOBE CONFIDENTIAL
   * ___________________
   *
   *  Copyright 2018 Adobe Systems Incorporated
   *  All Rights Reserved.
   *
   * NOTICE:  All information contained herein is, and remains
   * the property of Adobe Systems Incorporated and its suppliers,
   * if any.  The intellectual and technical concepts contained
   * herein are proprietary to Adobe Systems Incorporated and its
   * suppliers and are protected by all applicable intellectual property
   * laws, including trade secret and copyright laws.
   * Dissemination of this information or reproduction of this material
   * is strictly forbidden unless prior written permission is obtained
   * from Adobe Systems Incorporated.
   **************************************************************************/

exports.default = getLocalizedURLFromIMS;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getAppLocale = __webpack_require__(1);

var _getAppLocale2 = _interopRequireDefault(_getAppLocale);

var _utils = __webpack_require__(0);

var _apps = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * @param {string} url - app url
 * @returns {string} locale name the app uses. Returns '' if no valid locale found
 */
var parseLocaleParam = function parseLocaleParam(url) {

  var locale = void 0;

  if (typeof url === 'string') {
    var app = (0, _utils.getAppNameFromURL)(url);

    if (app) {
      // Adobe Account uses 'lang=xx' parameter
      var paramName = _apps.langParamApp.includes(app) ? 'lang' : 'locale';
      var regex = new RegExp('(' + paramName + '=)(.*?)(?=&|$)');

      locale = (url.match(regex) || [])[2] || '';
      locale = (0, _getAppLocale2.default)(app, locale, 'en-US');
    }
  }

  return locale;
}; /*************************************************************************
   * ADOBE CONFIDENTIAL
   * ___________________
   *
   *  Copyright 2018 Adobe Systems Incorporated
   *  All Rights Reserved.
   *
   * NOTICE:  All information contained herein is, and remains
   * the property of Adobe Systems Incorporated and its suppliers,
   * if any.  The intellectual and technical concepts contained
   * herein are proprietary to Adobe Systems Incorporated and its
   * suppliers and are protected by all applicable intellectual property
   * laws, including trade secret and copyright laws.
   * Dissemination of this information or reproduction of this material
   * is strictly forbidden unless prior written permission is obtained
   * from Adobe Systems Incorporated.
   **************************************************************************/
exports.default = parseLocaleParam;

/***/ })
/******/ ]);
});
//# sourceMappingURL=adobe-locales.js.map